const AP = window.AP;

export { AP };
